import EventsListContainer from './components/List/EventsListContainer';
import EventDetailsContainer from './components/Details/EventDetailsContainer';
import './assets/scss/main.css';

export {EventDetailsContainer};

export default EventsListContainer;


// WEBPACK FOOTER //
// ./src/features/Events/index.js